import { QuizResponse } from "@platform/types/quiz.types";

export const normalizeQuizResponseData = (data: any): QuizResponse => {
  const dataWithQuestionSets = {
    ...data,
    questionSets: data.questions.reduce((acc: any, question: any) => {
      const header = question.header;

      const subheader = question.additional_info;

      const existingSet = acc.find((set: any) => set.header === header);

      if (existingSet) {
        existingSet.questions.push(question);
      } else {
        acc.push({
          header,
          subheader,
          questions: [question],
        });
      }

      return acc;
    }, []),
  };

  return dataWithQuestionSets;
};

export default normalizeQuizResponseData;
